// src/components/operationCenter/widgets/token/overview/TwMarketRelationshipsWidget.tsx
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import MarketRelationshipsCard from "@/components/tokenPage/overview/MarketRelationshipsCard";

const TwMarketRelationshipsWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      <TokenWidgetWrapper ticker={config.ticker} providers={["price"]}>
        <MarketRelationshipsCard />
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwMarketRelationshipsWidget;
